// extracted by mini-css-extract-plugin
module.exports = {"Messages__outcome":"member-operations__Covid19History__Messages__outcome","Messages__outcomeHeading":"member-operations__Covid19History__Messages__outcomeHeading"};